import { KeyRound, Lock, Plane, Plus, TerminalSquare } from "lucide-react";
import type { PublicUser } from "../../api";
import { PanelHeader } from "../../components/Panel";


export function AuthConsole(props: {
  mode: "player" | "gm";
  email: string;
  code: string;
  devCode: string;
  setEmail: (value: string) => void;
  setCode: (value: string) => void;
  onStartAuth: () => void;
  onVerifyAuth: () => void;
}) {
  return (
    <section className="login-console">
      <div className="panel login-panel">
        <PanelHeader icon={<KeyRound size={15} />} title={authPanelTitle(props.mode)} code="AUTH" />
        <div className="login-grid">
          <label>
            邮箱
            <input value={props.email} onChange={(event) => props.setEmail(event.target.value)} />
          </label>
          <button onClick={props.onStartAuth}>发送验证码</button>
          <label>
            验证码
            <input value={props.code} onChange={(event) => props.setCode(event.target.value)} placeholder={props.devCode || "000000"} />
          </label>
          <button onClick={props.onVerifyAuth}>进入{authSubmitSuffix(props.mode)}</button>
        </div>
      </div>
    </section>
  );
}

function authPanelTitle(mode: "player" | "gm"): string {
  if (mode === "gm") {
    return "GM 席位登录";
  }
  return "玩家席位登录";
}

function authSubmitSuffix(mode: "player" | "gm"): string {
  if (mode === "gm") {
    return " GM";
  }
  return " AOC";
}

export function CreateAirlinePanel({ user, onCreateGame }: { user: PublicUser | null; onCreateGame: () => void }) {
  return (
    <section className="login-console">
      <div className="panel login-panel">
        <PanelHeader icon={<Plane size={15} />} title="创建玩家航司" code="NEW" />
        <div className="empty-state">
          <strong>{user?.email ?? "当前席位"} 尚未创建航司</strong>
          <button className="primary-command" onClick={onCreateGame}>
            <Plus size={16} />
            创建远东联合航空
          </button>
        </div>
      </div>
    </section>
  );
}

export function AccessDenied({ user }: { user: PublicUser | null }) {
  return (
    <section className="login-console">
      <div className="panel login-panel">
        <PanelHeader icon={<Lock size={15} />} title="GM 权限不足" code="403" />
        <div className="empty-state">
          <strong>{user?.email ?? "当前账号"} 不是 GM 管理员</strong>
          <span>GM 控制台只开放给 D1/admin allowlist 或 ADMIN_EMAILS 中的账号。</span>
          <a className="text-link-button" href="/">
            返回玩家席位
          </a>
        </div>
      </div>
    </section>
  );
}

export function SystemPanel({ title, body }: { title: string; body: string }) {
  return (
    <section className="login-console">
      <div className="panel login-panel">
        <PanelHeader icon={<TerminalSquare size={15} />} title={title} code="SYS" />
        <div className="empty-state">
          <strong>{body}</strong>
        </div>
      </div>
    </section>
  );
}
